import { signedStatementValue, statementRowColor } from "./constants";

// Normalizuje odgovor GET /restaurants/{id}/financial-overview?from&to u oblik koji
// koriste Zarada i Obračuni (detalj + forma plaćanja). Svi dijelovi su opcioni -
// backend polja za razradu nisu u repou potpuno specificirana, vidi
// docs/2026/10/14_10_2026_Backend_specifikacija_finansije_4_ekrana.md ("Претпоставке").
const OPENING_KEYS = ["opening_balance", "opening"];
const CLOSING_KEYS = ["closing_balance", "closing"];
const TURNOVER_KEYS = ["turnover", "revenue", "order_revenue"];

const numberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export function parseOverview(data, fallbackCurrency = "") {
  const source = data || {};
  const statement = source.statement || {};
  const rawRows = Array.isArray(source.income_vs_costs) ? source.income_vs_costs : [];

  const findRow = (keys) => rawRows.find((row) => keys.includes(row.key));
  const openingRow = findRow(OPENING_KEYS);
  const closingRow = findRow(CLOSING_KEYS);
  const turnoverRow = findRow(TURNOVER_KEYS);

  const currentBalance = numberOrNull(source.current_balance);
  const opening = numberOrNull(statement.opening_balance ?? statement.opening) ?? numberOrNull(openingRow?.value);
  const closing =
    numberOrNull(statement.closing_balance ?? statement.closing) ??
    numberOrNull(closingRow?.value) ??
    currentBalance;
  const turnover = numberOrNull(statement.turnover) ?? numberOrNull(turnoverRow?.value);

  const rows = rawRows
    .filter((row) => !OPENING_KEYS.includes(row.key) && !CLOSING_KEYS.includes(row.key))
    .map((row) => ({
      key: row.key,
      label: row.label,
      kind: row.kind,
      value: signedStatementValue(row),
      color: statementRowColor(row),
      isCash: row.kind === "cash" || /cash|kes/i.test(String(row.key || "")),
    }));

  const net = opening !== null && closing !== null ? closing - opening : null;

  return {
    currency: source.currency || fallbackCurrency,
    currentBalance,
    kpis: Array.isArray(source.kpis) ? source.kpis : [],
    rows,
    opening,
    closing,
    turnover,
    net,
    deductions: turnover !== null && net !== null ? turnover - net : null,
    // statement_check.ok === false -> razrada se ne slaže sa saldom
    checkFailed: !!source.statement_check && source.statement_check.ok === false,
    checkOk: !!source.statement_check && source.statement_check.ok === true,
    daily: Array.isArray(source.daily_turnover) ? source.daily_turnover : [],
    activity: Array.isArray(source.recent_activity) ? source.recent_activity : [],
  };
}
